<template>
  <v-container :class="{contain: $vuetify.breakpoint.mdAndUp}" fluid>
      <v-row v-if="!CardsToShow">
          <v-col
            :cols="12"
            :sm="12"
            :md="12"
            :lg="6"
            :xl="6"
            v-for="disc in showDiscs"
            :key="disc.id"
        >
            <DiscCardView
                :model="disc.model"
                :brand="disc.brand"
                :subtitle="disc.stability + ' ' + disc.type"
                :speed="disc.speed"
                :glide="disc.glide"
                :turn="disc.turn"
                :fade="disc.fade"
                :skill="disc.skill"
                :best="disc.best"
                :stability="disc.stability"
                :type="disc.type"
                :id="disc.id"
                :isBag="false"
                :image="disc.image"
                :shop="disc.shop"
            />
        </v-col>
      </v-row>
      <v-row v-if="CardsToShow">
          <v-col
            :cols="12"
            :sm="12"
            :md="12"
            :lg="6"
            :xl="6"
            v-for="disc in showDiscs"
            :key="disc.id"
        >
            <DiscCardViewSmall
                :model="disc.model"
                :brand="disc.brand"
                :subtitle="disc.stability + ' ' + disc.type"
                :speed="disc.speed"
                :glide="disc.glide"
                :turn="disc.turn"
                :fade="disc.fade"
                :skill="disc.skill"
                :best="disc.best"
                :stability="disc.stability"
                :type="disc.type"
                :id="disc.id"
                :isBag="false"
                :image="disc.image"
                :shop="disc.shop"
            />
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
import ListManipulator from "../../utils/ListManipulator/ListManipulator";
import DiscCardView from "../DiscCard/DiscCardView";
import DiscCardViewSmall from "../DiscCard/DiscCardViewSmall";
import Sorter from "../../utils/Sorter/Sorter.js";
import BadgeAdder from "../../utils/BadgeAdder/BadgeAdder.js";

export default {
    name: "DiscListView",
    components: {
        DiscCardView, DiscCardViewSmall,
    },
    props: {
        discCraftDiscs: {
            type: Array,
            required: true
        },
        search: {
            type: Object,
            require: true,
            default: function() {return {}}
        }
    },
    data: () => ({
        shown: 4,
        listLength: 0
    }),
    methods: {
    },

    computed: {
        showDiscs: function(){
            let listMani = new ListManipulator();
            let sorter = new Sorter();
            let adder = new BadgeAdder();
            let firstPhase = listMani.GetMatches(this.discCraftDiscs, this.search);
            let secondPhase = sorter.Sort(firstPhase, this.search);
            let thirdPhase = sorter.PlaceMatches(this.discCraftDiscs, secondPhase, this.search);
            let forthPhase = adder.AddTrue(thirdPhase, this.search);
            if (this.search.model != undefined || this.search.model != null){
                return forthPhase.splice(0,4);
            }
            else{
                return forthPhase /*.splice(0,4)*/;
            }
        },
        CardsToShow()
        {
            switch(this.$vuetify.breakpoint.name)
            {
                case "xs": return true;
                case "sm": return true;
                case "md": return true;
                case "lg": return false;
                case "xl": return false;
                default: return false;
            }
        }
    }
}
</script>

<style scoped>
.contain {
    width: 85%
}
</style>